import "./App.css";
import Home from "./pages/Home/Home";
// import Auth from "./pages/Auth/Auth";
// import Profile from "./pages/Profile/Profile";

function App() {
   return (
      <div className="App">
         <Home/>
         {/* <Profile /> */}
         {/* <Auth /> */}
      </div>
   );
}

export default App;
